export default __webpack_public_path__ + "static/media/mtgLogoBlack.eb7e0fca.svg";